document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector("[call-us-information]")) {
        import(/* webpackChunkName: "contact-us-block" */ "/Features/Components/ContactUs/js/contact-us-block.js").then(async (module) => {
            const contactUsBlock = new module.default();
            await contactUsBlock.init();
        });
    }
});
